module.exports = __webpack_public_path__ + "static/media/magicdecor.85c7880e.PNG";